<div class="sp-py-8" ui-row>
  <div class="text-color-gray-7 fs-12px heading">{{ heading }}</div>
</div>
